import {
  createAbsoluteUrl,
  type Language,
  type Country,
} from '@seek/melways-sites';

export const getLanguageSwitcher = (
  pathname: string | null,
  country: Country,
) => {
  /**
   * Use pathname that's read after browser has loaded
   * So that the pathname actually uses the actual original path
   * The regex /\/(th|id)(\/|$)/g matches any occurrence of '/th' or '/id' followed by either a '/' or the end of the string.
   * It replaces these occurrences with a single '/'.
   * /identity ❌
   * /identity/ ❌
   * /id/profile ✅ => /profile
   * /th/profile ✅ => /profile
   */
  const pagePath = pathname?.replace(/\/(th|id|zh)(\/|$)/g, '/') ?? '';
  switch (country) {
    case 'id':
      return {
        en: { url: pagePath },
        id: { url: `/id${pagePath}` },
      };
    case 'th':
      return {
        en: { url: pagePath },
        th: { url: `/th${pagePath}` },
      };
    case 'hk':
      return {
        en: { url: pagePath },
        zh: { url: `/zh${pagePath}` },
      };
  }
  return {};
};

const createCandidateHref = (
  language: Language,
  country: Country,
  path: string,
) => createAbsoluteUrl({ country, language, path, product: 'candidate' });

export const hreflangs = (route: string) => [
  {
    hreflang: 'en-my',
    href: createCandidateHref('en', 'my', route),
  },
  {
    hreflang: 'en-sg',
    href: createCandidateHref('en', 'sg', route),
  },
  {
    hreflang: 'en-ph',
    href: createCandidateHref('en', 'ph', route),
  },
  {
    hreflang: 'en-id',
    href: createCandidateHref('en', 'id', route),
  },
  {
    hreflang: 'id-id',
    href: createCandidateHref('id', 'id', route),
  },
  {
    hreflang: 'en-hk',
    href: createCandidateHref('en', 'hk', route),
  },
  {
    hreflang: 'zh-hk',
    href: createCandidateHref('zh', 'hk', route),
  },
  {
    hreflang: 'en-th',
    href: createCandidateHref('en', 'th', route),
  },
  {
    hreflang: 'th-th',
    href: createCandidateHref('th', 'th', route),
  },
  {
    hreflang: 'en-au',
    href: createCandidateHref('en', 'au', route),
  },
  {
    hreflang: 'en-nz',
    href: createCandidateHref('en', 'nz', route),
  },
];
